import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";
import { Search } from "@mui/icons-material";
import {
  getCrmDashboard,
  getOpportunitySummary,
  getOpportunityValueSummary,
  getTopBusinessSizesSummary,
  getTopCountriesSummary,
  getTopDealsSummary,
  getTopIndustryTypesSummary,
  getTopPrioritiesSummary,
  getTopSourcesSummary,
} from "../../../../services/crm/crmReportService";
import { Table } from "react-bootstrap";
import {
  abbrMonthName,
  abbrNum,
  formatDate,
  formatPercent,
} from "../../../../utils/utils";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { DialogActions, IconButton, Typography } from "@material-ui/core";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import SearchFiscalPeriod from "../../setup/finance/searchFiscalPeriod";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { DateTime } from "luxon";
function CrmDashboard(props) {
  const {
    companyProfile,
    currentFiscalYear,
    currentFiscalPeriod,
    reload,
  } = useGlobalData();
  const [
    openSearchFiscalYearOpportunityValueSummary,
    setOpenSearchFiscalYearOpportunityValueSummary,
  ] = useState(false);
  const [
    openSearchFiscalYearOpportunitySummary,
    setOpenSearchFiscalYearOpportunitySummary,
  ] = useState(false);
  const [
    openSearchFiscalYearSalesPipelineStage,
    setOpenSearchFiscalYearSalesPipelineStage,
  ] = useState(false);
  const [
    openSearchFiscalYearDealsStage,
    setOpenSearchFiscalYearDealsStage,
  ] = useState(false);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [
    openSearchFiscalPeriodTopSources,
    setOpenSearchFiscalPeriodTopSources,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopDeals,
    setOpenSearchFiscalPeriodTopDeals,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopIndustryTypes,
    setOpenSearchFiscalPeriodTopIndustryTypes,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopBusinessSizes,
    setOpenSearchFiscalPeriodTopBusinessSizes,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopCountries,
    setOpenSearchFiscalPeriodTopCountries,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopPriorities,
    setOpenSearchFiscalPeriodTopPriorities,
  ] = useState(false);
  const [openSearchFiscalPeriod, setOpenSearchFiscalPeriod] = useState(false);
  const [
    fiscalYearOpportunityValueSummary,
    setFiscalYearOpportunityValueSummary,
  ] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [
    fiscalYearOpportunitySummary,
    setFiscalYearOpportunitySummary,
  ] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [
    fiscalYearSalesPipelineStage,
    setFiscalYearSalesPipelineStage,
  ] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearDealsStage, setFiscalYearDealsStage] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalPeriodTopSources, setFiscalPeriodTopSources] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [fiscalPeriodTopDeals, setFiscalPeriodTopDeals] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [
    fiscalPeriodTopIndustryTypes,
    setFiscalPeriodTopIndustryTypes,
  ] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [
    fiscalPeriodTopBusinessSizes,
    setFiscalPeriodTopBusinessSizes,
  ] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [fiscalPeriodTopCountries, setFiscalPeriodTopCountries] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [fiscalPeriodTopPriorities, setFiscalPeriodTopPriorities] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );

  const [totalLeads, setTotalLeads] = useState(0);
  const [totalLeadsPercent, setTotalLeadsPercent] = useState(0);
  const [totalOpportunityRatio, setTotalOpportunityRatio] = useState(0);
  const [
    totalOpportunityRatioPercent,
    setTotalOpportunityRatioPercent,
  ] = useState(0);
  const [totalDealsInPipeline, setTotalDealsInPipeline] = useState(0);
  const [
    totalDealsInPipelinePercent,
    setTotalDealsInPipelinePercent,
  ] = useState(0);
  const [totalWinRate, setTotalWinRate] = useState(0);
  const [totalWinRatePercent, setTotalWinRatePercent] = useState(0);
  const [
    totalOpenOpportunitiesThisMonth,
    setTotalOpenOpportunitiesThisMonth,
  ] = useState(0);
  const [
    totalOpenOpportunitiesLastMonth,
    setTotalOpenOpportunitiesLastMonth,
  ] = useState(0);
  const [
    totalOpenOpportunitiesPercent,
    setTotalOpenOpportunitiesPercent,
  ] = useState(0);
  const [
    totalOpenOpportunitiesValueThisMonth,
    setTotalOpenOpportunitiesValueThisMonth,
  ] = useState(0);
  const [
    totalOpenOpportunitiesValueLastMonth,
    setTotalOpenOpportunitiesValueLastMonth,
  ] = useState(0);
  const [
    totalOpenOpportunitiesValuePercent,
    setTotalOpenOpportunitiesValuePercent,
  ] = useState(0);
  const [
    totalAverageDealsWonValueThisMonth,
    setTotalAverageDealsWonValueThisMonth,
  ] = useState(0);
  const [
    totalAverageDealsWonValueLastMonth,
    setTotalAverageDealsWonValueLastMonth,
  ] = useState(0);
  const [
    totalAverageDealsWonValuePercent,
    setTotalAverageDealsWonValuePercent,
  ] = useState(0);
  const [
    totalAverageSalesLifeCycleThisMonth,
    setTotalAverageSalesLifeCycleThisMonth,
  ] = useState(0);
  const [
    totalAverageSalesLifeCycleLastMonth,
    setTotalAverageSalesLifeCycleLastMonth,
  ] = useState(0);
  const [
    totalAverageSalesLifeCyclePercent,
    setTotalAverageSalesLifeCyclePercent,
  ] = useState(0);

  const [
    opportunityValueSummaryAmount,
    setOpportunityValueSummaryAmount,
  ] = useState({
    totalOpportunityValue: 0,
    totalWonDealsValue: 0,
    totalLostDealsValue: 0,
  });
  const [
    opportunityValueSummaryData,
    setOpportunityValueSummaryData,
  ] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Open Opportunities",
        borderColor: "#0096ec",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Won Deals",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Lost Deals",
        borderColor: "#f1416c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const opportunityValueSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [opportunitySummaryAmount, setOpportunitySummaryAmount] = useState({
    totalNewLeads: 0,
    totalOpportunity: 0,
    totalWonDeals: 0,
    totalLostDeals: 0,
  });
  const [opportunitySummaryData, setOpportunitySummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "New Leads",
        borderColor: "#6610f2",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Open Opportunities",
        borderColor: "#0096ec",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Won Deals",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Lost Deals",
        borderColor: "#f1416c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const opportunitySummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [topSourcesSummaryData, setTopSourcesSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topSourcesSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topSourcesSummaryPlugins = {
    id: "topSourcesSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topSourcesSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [topDealsSummaryData, setTopDealsSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topDealsSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topDealsSummaryPlugins = {
    id: "topDealsSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topDealsSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [
    topIndustryTypesSummaryData,
    setTopIndustryTypesSummaryData,
  ] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topIndustryTypesSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topIndustryTypesSummaryPlugins = {
    id: "topIndustryTypesSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topIndustryTypesSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [
    topBusinessSizesSummaryData,
    setTopBusinessSizesSummaryData,
  ] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: ["#12b18c", "#0096ec", "#6610f2"],
        hoverBackgroundColor: ["#12b18c", "#0096ec", "#6610f2"],
      },
    ],
  });

  const topBusinessSizesSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topBusinessSizesSummaryPlugins = {
    id: "topBusinessSizesSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topBusinessSizesSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [topCountriesSummaryData, setTopCountriesSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topCountriesSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topCountriesSummaryPlugins = {
    id: "topCountriesSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topCountriesSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [topPrioritiesSummaryData, setTopPrioritiesSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: ["#12b18c", "#0096ec", "#6610f2"],
        hoverBackgroundColor: ["#12b18c", "#0096ec", "#6610f2"],
      },
    ],
  });

  const topPrioritiesSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topPrioritiesSummaryPlugins = {
    id: "topPrioritiesSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topPrioritiesSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [
    salesPipelineStageSummaryData,
    setSalesPipelineStageSummaryData,
  ] = useState({
    labels: [
      "Prospecting",
      "Initiate Contact",
      "Identify Needs",
      "Present Offers",
      "Manage Objections",
    ],
    datasets: [
      {
        type: "bar",
        labels: "Sales Pipeline Stage",
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        data: [0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 4,
        borderRadius: 10,
      },
    ],
  });

  const salesPipelineStageSummaryOptions = {
    indexAxis: "y",
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [dealsStageSummaryData, setDealsStageSummaryData] = useState({
    labels: [
      "Prospecting",
      "Initiate Contact",
      "Identify Needs",
      "Present Offers",
      "Manage Objections",
    ],
    datasets: [
      {
        type: "bar",
        labels: "Deals Stage",
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        data: [0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 4,
        borderRadius: 10,
      },
    ],
  });

  const dealsStageSummaryOptions = {
    indexAxis: "y",
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  async function getCrmDashboardData(fiscalYearID = 0, fiscalPeriodID = 0) {
    const response = await getCrmDashboard(fiscalYearID, fiscalPeriodID);
    const { data } = response.data;
    const {
      leadsHeader,
      opportunityRatioHeader,
      dealsInPipelineHeader,
      winRateHeader,
      openOpportunitiesHeader,
      openOpportunitiesValueHeader,
      averageDealsWonValueHeader,
      averageSalesLifeCycleHeader,
      opportunityValueSummary,
      opportunitySummary,
      topSourcesSummary,
      topDealsSummary,
      topIndustryTypesSummary,
      topBusinessSizesSummary,
      topCountriesSummary,
      topPrioritiesSummary,
    } = data;
    setTotalLeads(leadsHeader.totalLeads);
    setTotalLeadsPercent(leadsHeader.totalLeadsPercent);
    setTotalOpportunityRatio(opportunityRatioHeader.totalOpportunityRatio);
    setTotalOpportunityRatioPercent(
      opportunityRatioHeader.totalOpportunityRatioPercent
    );
    setTotalDealsInPipeline(dealsInPipelineHeader.totalDealsInPipeline);
    setTotalDealsInPipelinePercent(
      dealsInPipelineHeader.totalDealsInPipelinePercent
    );
    setTotalWinRate(winRateHeader.totalWinRate);
    setTotalWinRatePercent(winRateHeader.totalWinRatePercent);
    setTotalOpenOpportunitiesThisMonth(
      openOpportunitiesHeader.totalOpenOpportunitiesThisMonth
    );
    setTotalOpenOpportunitiesLastMonth(
      openOpportunitiesHeader.totalOpenOpportunitiesLastMonth
    );
    setTotalOpenOpportunitiesPercent(
      openOpportunitiesHeader.totalOpenOpportunitiesPercent
    );
    setTotalOpenOpportunitiesValueThisMonth(
      openOpportunitiesValueHeader.totalOpenOpportunitiesValueThisMonth
    );
    setTotalOpenOpportunitiesValueLastMonth(
      openOpportunitiesValueHeader.totalOpenOpportunitiesValueLastMonth
    );
    setTotalOpenOpportunitiesValuePercent(
      openOpportunitiesValueHeader.totalOpenOpportunitiesValuePercent
    );
    setTotalAverageDealsWonValueThisMonth(
      averageDealsWonValueHeader.totalAverageDealsWonValueThisMonth
    );
    setTotalAverageDealsWonValueLastMonth(
      averageDealsWonValueHeader.totalAverageDealsWonValueLastMonth
    );
    setTotalAverageDealsWonValuePercent(
      averageDealsWonValueHeader.totalAverageDealsWonValuePercent
    );
    setTotalAverageSalesLifeCycleThisMonth(
      averageSalesLifeCycleHeader.totalAverageSalesLifeCycleThisMonth
    );
    setTotalAverageSalesLifeCycleLastMonth(
      averageSalesLifeCycleHeader.totalAverageSalesLifeCycleLastMonth
    );
    setTotalAverageSalesLifeCyclePercent(
      averageSalesLifeCycleHeader.totalAverageSalesLifeCyclePercent
    );
    setOpportunityValueSummaryData(opportunityValueSummary.datasets);
    setOpportunityValueSummaryAmount({
      totalOpportunityValue: opportunityValueSummary.totalOpportunityValue,
      totalWonDealsValue: opportunityValueSummary.totalWonDealsValue,
      totalLostDealsValue: opportunityValueSummary.totalLostDealsValue,
    });
    setOpportunitySummaryData(opportunitySummary.datasets);
    setOpportunitySummaryAmount({
      totalNewLeads: opportunitySummary.totalNewLeads,
      totalOpportunity: opportunitySummary.totalOpportunity,
      totalWonDeals: opportunitySummary.totalWonDeals,
      totalLostDeals: opportunitySummary.totalLostDeals,
    });
    setTopSourcesSummaryData(topSourcesSummary.datasets);
    setTopDealsSummaryData(topDealsSummary.datasets);
    setTopIndustryTypesSummaryData(topIndustryTypesSummary.datasets);
    setTopBusinessSizesSummaryData(topBusinessSizesSummary.datasets);
    setTopCountriesSummaryData(topCountriesSummary.datasets);
    setTopPrioritiesSummaryData(topPrioritiesSummary.datasets);
  }

  async function getOpportunityValueSummaryData(fiscalYearID = 0) {
    const response = await getOpportunityValueSummary(fiscalYearID);
    const { data } = response.data;
    setOpportunityValueSummaryData(data.opportunityValueSummary);
    setOpportunityValueSummaryAmount({
      totalOpportunityValue: data.totalOpportunityValue,
      totalWonDealsValue: data.totalWonDealsValue,
      totalLostDealsValue: data.totalLostDealsValue,
    });
  }

  async function getOpportunitySummaryData(fiscalYearID = 0) {
    const response = await getOpportunitySummary(fiscalYearID);
    const { data } = response.data;
    setOpportunitySummaryData(data.opportunitySummary);
    setOpportunitySummaryAmount({
      totalNewLeads: data.totalNewLeads,
      totalOpportunity: data.totalOpportunity,
      totalWonDeals: data.totalWonDeals,
      totalLostDeals: data.totalLostDeals,
    });
  }

  async function getTopSourcesSummaryData(fiscalPeriodID = 0) {
    const response = await getTopSourcesSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopSourcesSummaryData(data.topSourcesSummary);
  }

  async function getTopDealsSummaryData(fiscalPeriodID = 0) {
    const response = await getTopDealsSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopDealsSummaryData(data.topDealsSummary);
  }

  async function getTopIndustryTypesSummaryData(fiscalPeriodID = 0) {
    const response = await getTopIndustryTypesSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopIndustryTypesSummaryData(data.topIndustryTypesSummary);
  }

  async function getTopBusinessSizesSummaryData(fiscalPeriodID = 0) {
    const response = await getTopBusinessSizesSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopBusinessSizesSummaryData(data.topBusinessSizesSummary);
  }

  async function getTopCountriesSummaryData(fiscalPeriodID = 0) {
    const response = await getTopCountriesSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopCountriesSummaryData(data.topCountriesSummary);
  }

  async function getTopPrioritiesSummaryData(fiscalPeriodID = 0) {
    const response = await getTopPrioritiesSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopPrioritiesSummaryData(data.topPrioritiesSummary);
  }

  useEffect(() => {
    getCrmDashboardData(currentFiscalYear.ID, currentFiscalPeriod.ID);
  }, [reload]);

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-people-arrows" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Leads
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {abbrNum(totalLeads, 0)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalLeadsPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalLeadsPercent, 2, true)}
                      </Typography>
                    ) : totalLeadsPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalLeadsPercent, 2, true)}
                      </Typography>
                    ) : totalLeadsPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalLeadsPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-search-dollar" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Opportunity Ratio
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {abbrNum(totalOpportunityRatio, 2)}%
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalOpportunityRatioPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalOpportunityRatioPercent, 2, true)}
                      </Typography>
                    ) : totalOpportunityRatioPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalOpportunityRatioPercent, 2, true)}
                      </Typography>
                    ) : totalOpportunityRatioPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalOpportunityRatioPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-funnel-dollar" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Deals In Pipeline
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalDealsInPipeline, 2)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalDealsInPipelinePercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalDealsInPipelinePercent, 2, true)}
                      </Typography>
                    ) : totalDealsInPipelinePercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalDealsInPipelinePercent, 2, true)}
                      </Typography>
                    ) : totalDealsInPipelinePercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalDealsInPipelinePercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-trophy" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Win Rate
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {abbrNum(totalWinRate, 2)}%
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalWinRatePercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalWinRatePercent, 2, true)}
                      </Typography>
                    ) : totalWinRatePercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalWinRatePercent, 2, true)}
                      </Typography>
                    ) : totalWinRatePercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalWinRatePercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Opportunity Value Overview
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalYearOpportunityValueSummary.startMonthName
                          ) +
                            " " +
                            fiscalYearOpportunityValueSummary.year +
                            " - " +
                            abbrMonthName(
                              fiscalYearOpportunityValueSummary.endMonthName
                            ) +
                            " " +
                            fiscalYearOpportunityValueSummary.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearOpportunityValueSummary(
                                true
                              );
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-9 col-lg-9">
                <Chart
                  type="bar"
                  data={opportunityValueSummaryData}
                  options={opportunityValueSummaryOptions}
                  style={{ minHeight: "250px" }}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3 p-0">
                <div className="column">
                  <div className="col-sm-12 col-md-12 col-lg-12 pl-md-0">
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Opportunity
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(
                            opportunityValueSummaryAmount.totalOpportunityValue,
                            2
                          )}
                        </Typography>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Won Deals
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(
                            opportunityValueSummaryAmount.totalWonDealsValue,
                            2
                          )}
                        </Typography>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Lost Deals
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(
                            opportunityValueSummaryAmount.totalLostDealsValue,
                            2
                          )}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Opportunity Overview
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalYearOpportunitySummary.startMonthName
                          ) +
                            " " +
                            fiscalYearOpportunitySummary.year +
                            " - " +
                            abbrMonthName(
                              fiscalYearOpportunitySummary.endMonthName
                            ) +
                            " " +
                            fiscalYearOpportunitySummary.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearOpportunitySummary(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-9 col-lg-9">
                <Chart
                  type="bar"
                  data={opportunitySummaryData}
                  options={opportunitySummaryOptions}
                  style={{ minHeight: "250px" }}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3 p-0">
                <div className="column">
                  <div className="col-sm-12 col-md-12 col-lg-12 pl-md-0">
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total New Leads
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {abbrNum(opportunitySummaryAmount.totalNewLeads, 2)}
                        </Typography>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Opportunity
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {abbrNum(
                            opportunitySummaryAmount.totalOpportunity,
                            2
                          )}
                        </Typography>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Won Deals
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {abbrNum(opportunitySummaryAmount.totalWonDeals, 2)}
                        </Typography>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Lost Deals
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {abbrNum(opportunitySummaryAmount.totalLostDeals, 2)}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <Table borderless size="xl" responsive="xl">
              <tbody>
                <tr>
                  <td colSpan="2" className="px-0 py-0">
                    {totalOpenOpportunitiesPercent === 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-info"
                      >
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalOpenOpportunitiesPercent, 2, true)}
                      </Typography>
                    ) : totalOpenOpportunitiesPercent > 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-success"
                      >
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalOpenOpportunitiesPercent, 2, true)}
                      </Typography>
                    ) : totalOpenOpportunitiesPercent < 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-danger"
                      >
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalOpenOpportunitiesPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="px-0 pt-0 pb-2">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-center text-muted"
                    >
                      Open Opportunities
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="pl-0 py-0 border-right">
                    <Typography className="kt-font-bolder text-right">
                      {abbrNum(totalOpenOpportunitiesThisMonth, 2)}
                    </Typography>
                  </td>
                  <td className="pr-0 py-0">
                    <Typography className="kt-font-bolder">
                      {abbrNum(totalOpenOpportunitiesLastMonth, 2)}
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="pl-0 py-0 border-right">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-right text-muted"
                    >
                      This Month
                    </Typography>
                  </td>
                  <td className="pr-0 py-0">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-muted"
                    >
                      Last Month
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <Table borderless size="xl" responsive="xl">
              <tbody>
                <tr>
                  <td colSpan="2" className="px-0 py-0">
                    {totalOpenOpportunitiesValuePercent === 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-info"
                      >
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(
                          totalOpenOpportunitiesValuePercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : totalOpenOpportunitiesValuePercent > 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-success"
                      >
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(
                          totalOpenOpportunitiesValuePercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : totalOpenOpportunitiesValuePercent < 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-danger"
                      >
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(
                          totalOpenOpportunitiesValuePercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="px-0 pt-0 pb-2">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-center text-muted"
                    >
                      Open Opportunities Value
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="pl-0 py-0 border-right">
                    <Typography className="kt-font-bolder text-right">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalOpenOpportunitiesValueThisMonth, 2)}
                    </Typography>
                  </td>
                  <td className="pr-0 py-0">
                    <Typography className="kt-font-bolder">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalOpenOpportunitiesValueLastMonth, 2)}
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="pl-0 py-0 border-right">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-right text-muted"
                    >
                      This Month
                    </Typography>
                  </td>
                  <td className="pr-0 py-0">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-muted"
                    >
                      Last Month
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <Table borderless size="xl" responsive="xl">
              <tbody>
                <tr>
                  <td colSpan="2" className="px-0 py-0">
                    {totalAverageDealsWonValuePercent === 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-info"
                      >
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(
                          totalAverageDealsWonValuePercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : totalAverageDealsWonValuePercent > 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-success"
                      >
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(
                          totalAverageDealsWonValuePercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : totalAverageDealsWonValuePercent < 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-danger"
                      >
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(
                          totalAverageDealsWonValuePercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="px-0 pt-0 pb-2">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-center text-muted"
                    >
                      Average Deals Won Value
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="pl-0 py-0 border-right">
                    <Typography className="kt-font-bolder text-right">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalAverageDealsWonValueThisMonth, 2)}
                    </Typography>
                  </td>
                  <td className="pr-0 py-0">
                    <Typography className="kt-font-bolder">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalAverageDealsWonValueLastMonth, 2)}
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="pl-0 py-0 border-right">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-right text-muted"
                    >
                      This Month
                    </Typography>
                  </td>
                  <td className="pr-0 py-0">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-muted"
                    >
                      Last Month
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <Table borderless size="xl" responsive="xl">
              <tbody>
                <tr>
                  <td colSpan="2" className="px-0 py-0">
                    {totalAverageSalesLifeCyclePercent === 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-info"
                      >
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(
                          totalAverageSalesLifeCyclePercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : totalAverageSalesLifeCyclePercent > 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-success"
                      >
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(
                          totalAverageSalesLifeCyclePercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : totalAverageSalesLifeCyclePercent < 0 ? (
                      <Typography
                        variant="h5"
                        className="kt-font-bolder text-center text-danger"
                      >
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(
                          totalAverageSalesLifeCyclePercent,
                          2,
                          true
                        )}
                      </Typography>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" className="px-0 pt-0 pb-2">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-center text-muted"
                    >
                      Average Sales Life Cycle
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="pl-0 py-0 border-right">
                    <Typography className="kt-font-bolder text-right">
                      {abbrNum(totalAverageSalesLifeCycleThisMonth, 2)} Days
                    </Typography>
                  </td>
                  <td className="pr-0 py-0">
                    <Typography className="kt-font-bolder">
                      {abbrNum(totalAverageSalesLifeCycleLastMonth, 2)} Days
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="pl-0 py-0 border-right">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-right text-muted"
                    >
                      This Month
                    </Typography>
                  </td>
                  <td className="pr-0 py-0">
                    <Typography
                      variant="subtitle2"
                      className="kt-font-bold text-muted"
                    >
                      Last Month
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Sources
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalPeriodTopSources.monthName) +
                            " " +
                            fiscalPeriodTopSources.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopSources(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topSourcesSummaryData}
                  options={topSourcesSummaryOptions}
                  plugins={[topSourcesSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Deals
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalPeriodTopDeals.monthName) +
                            " " +
                            fiscalPeriodTopDeals.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopDeals(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topDealsSummaryData}
                  options={topDealsSummaryOptions}
                  plugins={[topDealsSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Industries
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalPeriodTopIndustryTypes.monthName
                          ) +
                            " " +
                            fiscalPeriodTopIndustryTypes.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopIndustryTypes(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topIndustryTypesSummaryData}
                  options={topIndustryTypesSummaryOptions}
                  plugins={[topIndustryTypesSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Businesses
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalPeriodTopBusinessSizes.monthName
                          ) +
                            " " +
                            fiscalPeriodTopBusinessSizes.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopBusinessSizes(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topBusinessSizesSummaryData}
                  options={topBusinessSizesSummaryOptions}
                  plugins={[topBusinessSizesSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Countries
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalPeriodTopCountries.monthName) +
                            " " +
                            fiscalPeriodTopCountries.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopCountries(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topCountriesSummaryData}
                  options={topCountriesSummaryOptions}
                  plugins={[topCountriesSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Top 5 Priorities
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalPeriodTopPriorities.monthName) +
                            " " +
                            fiscalPeriodTopPriorities.year}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriodTopPriorities(true);
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={topPrioritiesSummaryData}
                  options={topPrioritiesSummaryOptions}
                  plugins={[topPrioritiesSummaryPlugins]}
                  style={{ minHeight: "123px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Sales Pipeline Stage
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalYearSalesPipelineStage.startMonthName
                          ) +
                            " " +
                            fiscalYearSalesPipelineStage.year +
                            " - " +
                            abbrMonthName(
                              fiscalYearSalesPipelineStage.endMonthName
                            ) +
                            " " +
                            fiscalYearSalesPipelineStage.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearSalesPipelineStage(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={salesPipelineStageSummaryData}
                  options={salesPipelineStageSummaryOptions}
                  style={{ minHeight: "250px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Deals Stage
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalYearDealsStage.startMonthName) +
                            " " +
                            fiscalYearDealsStage.year +
                            " - " +
                            abbrMonthName(fiscalYearDealsStage.endMonthName) +
                            " " +
                            fiscalYearDealsStage.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearDealsStage(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={dealsStageSummaryData}
                  options={dealsStageSummaryOptions}
                  style={{ minHeight: "250px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            if (openSearchFiscalYearOpportunityValueSummary) {
              setFiscalYearOpportunityValueSummary({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearOpportunityValueSummary(false);
              getOpportunityValueSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearOpportunitySummary) {
              setFiscalYearOpportunitySummary({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearOpportunitySummary(false);
              getOpportunitySummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearSalesPipelineStage) {
              setFiscalYearSalesPipelineStage({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearSalesPipelineStage(false);
              //getSalesDashboardData(fiscalYear.ID);
            } else if (openSearchFiscalYearDealsStage) {
              setFiscalYearDealsStage({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearDealsStage(false);
              //getSalesDashboardData(fiscalYear.ID);
            }
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchFiscalPeriod}
        title="Search Fiscal Period"
        onCloseDialog={() => {
          setOpenSearchFiscalPeriod(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalPeriod
          onSelectFiscalPeriod={(fiscalPeriod) => {
            if (openSearchFiscalPeriodTopSources) {
              setFiscalPeriodTopSources({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopSources(false);
              getTopSourcesSummaryData(fiscalPeriod.ID);
            } else if (openSearchFiscalPeriodTopDeals) {
              setFiscalPeriodTopDeals({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopDeals(false);
              getTopDealsSummaryData(fiscalPeriod.ID);
            } else if (openSearchFiscalPeriodTopIndustryTypes) {
              setFiscalPeriodTopIndustryTypes({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopIndustryTypes(false);
              getTopIndustryTypesSummaryData(fiscalPeriod.ID);
            } else if (openSearchFiscalPeriodTopBusinessSizes) {
              setFiscalPeriodTopBusinessSizes({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopBusinessSizes(false);
              getTopBusinessSizesSummaryData(fiscalPeriod.ID);
            } else if (openSearchFiscalPeriodTopCountries) {
              setFiscalPeriodTopCountries({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopCountries(false);
              getTopCountriesSummaryData(fiscalPeriod.ID);
            } else if (openSearchFiscalPeriodTopPriorities) {
              setFiscalPeriodTopPriorities({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopPriorities(false);
              getTopPrioritiesSummaryData(fiscalPeriod.ID);
            }
            setOpenSearchFiscalPeriod(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalPeriod(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default CrmDashboard;
